// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xxsmall-badge-dc46372b"};